<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Lista historial
          </a>
        </div>
        <div class="col-sm-6 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm hide-xs" (click)="refresh()"><i class="fas fa-undo"></i> Refrescar
          </button>
          <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-3"></i>
          </button>          
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body" *ngIf="item != null" id="body">
        <div class="row">
          <div class="col-lg-3">
            <div class="card border border-dark">
              <div class="card-header bg-transparent border-dark">
                <h5 class="my-0 text-dark"><i class="fas fa-user-alt me-3 m-r-5"></i> <span
                    class="f-s-18 m-r-2">{{item.user_data.username}}</span> <span class="f-s-9">( Usuario )</span>
                </h5>
              </div>
              <div class="card-body text-center" style="padding: 10px 15px;">
                <h5 class="card-title">{{item.nro_voucher}}
                  <ng-container *ngIf="!item.status_closed">
                    <span class="badge badge-info f-s-13 m-l-5">Abierto</span>
                  </ng-container>
                  <ng-container *ngIf="item.status_closed">
                    <span class="badge badge-danger f-s-13 m-l-5">Cerrado</span>
                  </ng-container>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card border border-primary">
              <div class="card-header bg-transparent border-primary">
                <h5 class="my-0 text-primary">
                  <span class="f-s-16"><i class="fas fa-briefcase me-3 m-r-5"></i> Caja Principal  </span>
                  <span class="float-right f-s-11">{{item.date_opening | date: 'mediumDate'}}</span>
                </h5>
              </div>
              <div class="card-body text-center" style="padding: 10px 15px;">
                <h5 class="card-title">
                  <span class="f-s-9 m-r-5">Monto Apertura</span>
                  <span>{{toolsService.momeySol()}}{{item.amount_opening}}</span>
                </h5>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card border border-success">
              <div class="card-header bg-transparent border-success">
                <h5 class="my-0 text-success"><i class="fas fa-box-open me-3 m-r-5"></i> BALANCE</h5>
              </div>
              <div class="card-body text-center" style="padding: 10px 15px;">
                <h5 class="card-title">
                  {{toolsService.momeySol()}}{{item.balance}}
                </h5>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card border border-danger">
              <div class="card-header bg-transparent border-danger">
                <h5 class="my-0 text-danger">
                  <span class="f-s-16"><i class="fas fa-box me-3 m-r-5"></i> CIERRE CAJA</span>                  
                  <ng-container *ngIf="item.date_closing != null">
                    <span class="float-right f-s-11">{{item.date_closing | date: 'mediumDate'}}</span>
                  </ng-container>                  
                </h5>
              </div>
              <div class="card-body text-center" style="padding: 10px 15px;">
                <h5 class="card-title">
                  <ng-container *ngIf="!item.status_closed">
                    <span class="badge badge-danger f-s-9">Pendiente</span>
                  </ng-container>
                  <ng-container *ngIf="item.status_closed">
                    {{toolsService.momeySol()}}{{item.amount_closing}}
                  </ng-container>
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 m-t-10">
            <p class="form__group__title">
              <span class="text-success">RESUMEN INGRESOS <i class="fas fa-long-arrow-alt-left m-l-2 f-s-15"></i></span>
              <span class="m-l-10 f-s-11">( agrupados por concepto)</span>
            </p>
            <div class="row" *ngIf="incomes.length > 0">
              <ng-container *ngFor="let item of incomes">
                <div class="col-lg-6 m-b-15">
                  <div class="card m-b-0">
                    <div class="card-header bold p-t-5 p-b-5" style="color: black">
                      <i class="fas fa-check-circle m-r-5"></i> {{item.concept_description}}
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Glosa</th>
                              <th>Voucher</th>
                              <th>Emisor</th>
                              <th>M.Pago</th>
                              <th class="text-center">Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let detail of item.items" [ngClass]="{'text-danger': detail.deleted_at != null || detail.date_repayment != null}">
                              <td>
                                <ng-container *ngIf="detail.gloss != null">
                                  {{detail.gloss}}
                                </ng-container>
                                <ng-container *ngIf="detail.gloss == null">
                                  {{detail.description}}
                                </ng-container>
                                <ng-container *ngIf="detail.deleted_at != null">
                                  <div>
                                    <span class="badge badge-danger f-s-9">Anulado</span>
                                  </div>
                                </ng-container>
                              </td>
                              <td>
                                {{detail.nro_voucher}}
                                <ng-container *ngIf="detail.date_repayment != null">
                                  <div>
                                    <span class="badge badge-danger f-s-9">Comprobante de baja</span>
                                  </div>
                                </ng-container>
                              </td>
                              <td>
                                <ng-container *ngIf="detail.reference_emisor_receptor != null">
                                  <div>
                                    <p class="m-b-0"><span
                                        class="bold f-s-11">{{detail.reference_emisor_receptor.description}}:
                                      </span>{{detail.reference_emisor_receptor_data.fullname}}</p>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="detail.reference_emisor_receptor == null">
                                  <span>-</span>
                                </ng-container>
                              </td>
                              <td>
                                {{detail.paymethod.description}}
                              </td>
                              <td class="text-center">
                                {{detail.amount}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <hr style="height: 3px; background: red;">
        <div class="row">
          <div class="col-lg-12 m-t-20">
            <p class="form__group__title">
              <span class="text-danger">RESUMEN EGRESOS <i class="fas fa-long-arrow-alt-right m-l-2 f-s-15"></i></span>
              <span class="m-l-10 f-s-11">( agrupados por concepto)</span>
            </p>
            <div class="row" *ngIf="expenses.length > 0">
              <ng-container *ngFor="let item of expenses">
                <div class="col-lg-6 m-b-15">
                  <div class="card m-b-0">
                    <div class="card-header bold p-t-5 p-b-5" style="color: black">
                      <i class="fas fa-check-circle m-r-5"></i> {{item.concept_description}}
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-sm table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>Glosa</th>
                              <th>Voucher</th>
                              <th>Receptor</th>
                              <th>M.Pago</th>
                              <th class="text-center">Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let detail of item.items" [ngClass]="{'text-danger': detail.deleted_at != null }">
                              <td>
                                <ng-container *ngIf="detail.gloss != null">
                                  {{detail.gloss}}
                                </ng-container>
                                <ng-container *ngIf="detail.gloss == null">
                                  {{detail.description}}
                                </ng-container>
                                <ng-container *ngIf="detail.deleted_at != null">
                                  <div>
                                    <span class="badge badge-danger f-s-9">Anulado</span>
                                  </div>
                                </ng-container>
                              </td>
                              <td>
                                {{detail.nro_voucher}}
                              </td>
                              <td>
                                <ng-container *ngIf="detail.reference_emisor_receptor != null">
                                  <div>
                                    <p class="m-b-0"><span
                                        class="bold f-s-11">{{detail.reference_emisor_receptor.description}}:
                                      </span>{{detail.reference_emisor_receptor_data.fullname}}</p>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="detail.reference_emisor_receptor == null">
                                  <span>-</span>
                                </ng-container>
                              </td>
                              <td>
                                {{detail.paymethod.description}}
                              </td>
                              <td class="text-center">
                                {{detail.amount}}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

        </div>

        <div class="row" style="display: none;">
          <div class="col-12">
            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-bs-toggle="tab" href="#home" role="tab" target="_self">
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">
                    Ingresos <i class="fas fa-long-arrow-alt-left text-success m-l-2 f-s-15"></i>
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-bs-toggle="tab" href="#profile" role="tab">
                  <span class="d-block d-sm-none"><i class="far fa-user"></i></span>
                  <span class="d-none d-sm-block">
                    Egresos <i class="fas fa-long-arrow-alt-right text-danger m-l-2 f-s-15"></i>
                  </span>
                </a>
              </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content p-l-0 p-r-0 p-t-15 p-b-15 text-muted">
              <div class="tab-pane active" id="home" role="tabpanel">
                <div class="row" *ngIf="incomes.length > 0">
                  <ng-container *ngFor="let item of incomes">
                    <div class="col-lg-6 m-b-15">
                      <div class="card m-b-0">
                        <div class="card-header bold" style="color: black">
                          <i class="fas fa-check-circle m-r-5"></i> {{item.concept_description}}
                        </div>
                        <div class="card-body p-5">
                          <div class="table-responsive">
                            <table class="table table-hover table-sm mb-0">
                              <thead class="thead-default">
                                <tr>
                                  <th>Glosa</th>
                                  <th>N° voucher</th>
                                  <th>Medio Pago</th>
                                  <th>Monto</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let detail of item.items">
                                  <td>
                                    <ng-container *ngIf="detail.gloss != null">
                                      {{detail.gloss}}
                                    </ng-container>
                                    <ng-container *ngIf="detail.gloss == null">
                                      {{detail.description}}
                                    </ng-container>
                                  </td>
                                  <td>
                                    {{detail.nro_voucher}}
                                  </td>
                                  <td>
                                    {{detail.paymethod}}
                                  </td>
                                  <td>
                                    {{detail.amount | currency:'S/ '}}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="tab-pane" id="profile" role="tabpanel">
                <p class="mb-0">
                  Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation
                  +1
                  labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table
                  craft
                  beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad
                  vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus mollit. Keytar
                  helvetica VHS salvia yr, vero magna velit sapiente labore stumptown. Vegan fanny pack odio cillum wes
                  anderson 8-bit.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
